import { render, staticRenderFns } from "./MilliGemiSicilineKayitliGemilerForm.vue?vue&type=template&id=0df308cb&scoped=true"
import script from "./MilliGemiSicilineKayitliGemilerForm.vue?vue&type=script&lang=ts"
export * from "./MilliGemiSicilineKayitliGemilerForm.vue?vue&type=script&lang=ts"
import style0 from "./MilliGemiSicilineKayitliGemilerForm.vue?vue&type=style&index=0&id=0df308cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df308cb",
  null
  
)

export default component.exports